export const GTMResetEcommerce = () => {
  const w = window as any

  w.dataLayer = w.dataLayer || []
  w.dataLayer.push({ ecommerce: null })
}
